import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/globals.css'; // Ensure global styles are imported 
import App from './App';
import reportWebVitals from './reportWebVitals';// Ensure global styles are imported
import { initMetaPixel } from './services/metaPixel';

// Bind the pixel before the first render so no early event is attributed to
// an uninitialised pixel. No-ops when REACT_APP_META_PIXEL_ID is unset.
initMetaPixel();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
